import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AirlineMap, AirportMap } from "../../../types";

export interface FlightPostBookingState {
  context: {
    airports: AirportMap;
    airlines: AirlineMap;
  };
  selectedItineraryId: string | null;
}

export const initialPostBookingState: FlightPostBookingState = {
  context: { airports: {}, airlines: {} },
  selectedItineraryId: null,
};

export const flightPostBookingSlice = createSlice({
  name: "flightPostBooking",
  initialState: initialPostBookingState,
  reducers: {
    updateContext: (
      state,
      action: PayloadAction<{ airports: AirportMap; airlines: AirlineMap }>
    ) => {
      state.context.airports = {
        ...state.context.airports,
        ...action.payload.airports,
      };
      state.context.airlines = {
        ...state.context.airlines,
        ...action.payload.airlines,
      };
    },
    setSelectedItineraryId: (state, action: PayloadAction<string | null>) => {
      state.selectedItineraryId = action.payload;
    },
  },
});

export const FlightPostBookingActions = flightPostBookingSlice.actions;
export default flightPostBookingSlice.reducer;
